module.exports = __webpack_public_path__ + "img/company.f50c4b02.svg";